import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { RugbyMatchRowWrapper } from './styles';
import TeamLabel from '../TeamLabel';
import ConfigManager from '../../common/configManager/configManager';
import * as status from '../../constants/';
import Label from '../shared/Label';

const RugbyMatchRow = ({
  matchRow, isMobile, competitionId,
}) => {
  const rugbyTeamsUrl = ConfigManager.getRugbyTeams('min');
  const isHomeWinner = () => (Number(matchRow.getIn(['teamHome', 'score'])))
    > (Number(matchRow.getIn(['teamAway', 'score']))) && matchRow.get('status') !== status.FIXTURE;
  const isAwayWinner = () => (Number(matchRow.getIn(['teamHome', 'score'])))
    < (Number(matchRow.getIn(['teamAway', 'score']))) && matchRow.get('status') !== status.FIXTURE;
  const isLive = () => (matchRow.get('status') === status.PLAYING);

  const formatDate = (datePassed) => {
    const dateJs = new Date(datePassed);
    const hours = (`0${dateJs.getHours()
      .toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    const minutes = (`0${dateJs.getMinutes()
      .toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    return `${hours}:${minutes}`;
  };

  const parseStatus = (match) => {
    let statusToReturn = formatDate(`${match.get('utcDate')}`);

    if (match.get('status')) {
      if (match.get('status') === status.RESULT) {
        statusToReturn = 'Fine';
      } else if (match.get('status') === status.POSTPONED_STATUS) {
        statusToReturn = 'Posticipato';
      } else if (match.get('status') === status.CANCELLED) {
        statusToReturn = 'Cancellato';
      }
    }

    return statusToReturn;
  };

  return (
    <RugbyMatchRowWrapper>
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
      }}
      >
        <Col
          onClick={event => event.preventDefault()}
          md={0.6}
          sm={0.6}
          xs={0.6}
          style={{
            top: isMobile ? '-15px' : '',
            paddingLeft: isMobile ? '10px' : '15px',
            paddingRight: isMobile ? '0px' : '10px',
          }}
        />
        {isMobile &&
          <Col sm={6.5} xs={6.5} style={{ paddingRight: 0, paddingLeft: 0 }}>
            <TeamLabel
              label={matchRow.getIn(['teamHome', 'name'])}
              color="black"
              image={`${rugbyTeamsUrl}${matchRow.getIn(['teamHome', 'teamId'])}.png`}
              marginLeft={0.4}
              font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
            <TeamLabel
              label={matchRow.getIn(['teamAway', 'name'])}
              color="black"
              image={`${rugbyTeamsUrl}${matchRow.getIn(['teamAway', 'teamId'])}.png`}
              marginLeft={0.4}
              font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
          </Col>
        }
        {!isMobile &&
          <Col md={3.5} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <TeamLabel
              label={matchRow.getIn(['teamHome', 'name'])}
              color="black"
              image={`${rugbyTeamsUrl}${matchRow.getIn(['teamHome', 'teamId'])}.png`}
              marginLeft={0.5}
              font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
          </Col>
        }
        {!isMobile &&
          <Col md={3.5} style={{ paddingLeft: '5px', paddingRight: 0 }}>
            <TeamLabel
              label={matchRow.getIn(['teamAway', 'name'])}
              color="black"
              image={`${rugbyTeamsUrl}${matchRow.getIn(['teamAway', 'teamId'])}.png`}
              marginLeft={0.5}
              font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
          </Col>
        }
        <Col
          lg={1.4}
          md={2}
          sm={2}
          xs={2}
          style={{
            paddingLeft: 0,
            paddingRight: '0px',
          }}
        >
          <Label
            label={parseStatus(matchRow)}
            size={isMobile ? 0.7 : 0.9}
            isTitleNarrowMedium={matchRow.get('status') && matchRow.get('status') === status.RESULT}
          />
        </Col>
        <Col
          lg={2.2}
          md={1.8}
          sm={1.8}
          xs={1.8}
          style={{
            paddingRight: 0,
            paddingLeft: isMobile ? '0px' : '5px',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-evenly',
          }}
        >
          <Label
            label={(matchRow.get('status') !== status.FIXTURE && matchRow.getIn(['teamHome', 'score'])) ?
              matchRow.getIn(['teamHome', 'score']) : '-'}
            color={isLive() ? 'liveColor' : 'black'}
            margin={isMobile ? '0.8em' : '0.6em'}
            size={isMobile ? 0.85 : 1}
            lineHeight={1}
            isTitleNarrowMedium={isHomeWinner()}
          />
          <Label
            label={(matchRow.get('status') !== status.FIXTURE && matchRow.getIn(['teamAway', 'score'])) ?
              matchRow.getIn(['teamAway', 'score']) : '-'}
            color={isLive() ? 'liveColor' : 'black'}
            margin={isMobile ? '0.8em' : '0.6em'}
            size={isMobile ? 0.85 : 1}
            lineHeight={1}
            isTitleNarrowMedium={isAwayWinner()}
          />
        </Col>
        <Col
          lg={0.75}
          md={1}
          sm={1}
          xs={1}
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row',
            paddingRight: isMobile ? '0px' : '10px',
            paddingLeft: isMobile ? '0' : '15px',
            opacity: competitionId === 2 ? '0' : '1',
          }}
        >
          {/*<IconFont
            className="icon-matchcenter-right-arrow"
            color="selectedColor"
            font={18}
            weight="bold"
            withCursor
          />*/}
          <div />
        </Col>
      </Row>
    </RugbyMatchRowWrapper>
  );
};

RugbyMatchRow.propTypes = {
  matchRow: PropTypes.any,
  isMobile: PropTypes.any,
  competitionId: PropTypes.any,
};

export default RugbyMatchRow;



// WEBPACK FOOTER //
// ./src/components/RubgyMatchRow/index.js